import useSmsCreditAccess from "@/modules/smsCredit/useSmsCreditAccess";
import walletService from "@/services/wallet";
import { useQuery } from "@tanstack/react-query";

function useGetWallet() {
  const { allowed } = useSmsCreditAccess();
  return useQuery(
    ["getWalletBalance"],
    walletService.getWalletBalance,
    { enabled: allowed, refetchOnWindowFocus: true, refetchOnMount: "always" }
  );

}

export default useGetWallet;
